
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateExpenseRequest,
  ExpenseListResource,
  ExpenseProjectInfoResource,
  ExpenseReceiptResponse,
  ExpenseResource,
} from '../models';
import {
    CreateExpenseRequestFromJSON,
    CreateExpenseRequestToJSON,
    ExpenseListResourceFromJSON,
    ExpenseListResourceToJSON,
    ExpenseProjectInfoResourceFromJSON,
    ExpenseProjectInfoResourceToJSON,
    ExpenseReceiptResponseFromJSON,
    ExpenseReceiptResponseToJSON,
    ExpenseResourceFromJSON,
    ExpenseResourceToJSON,
} from '../models';

export interface CreateProjectExpenseRequest {
    projectId: string;
    createExpenseRequest: CreateExpenseRequest;
}

export interface DeleteExpenseRequest {
    projectId: string;
    expenseId: string;
}

export interface GetExpenseInvoiceRequest {
    projectId: string;
    expenseId: string;
    type?: GetExpenseInvoiceTypeEnum;
}

export interface GetProjectExpenseInfoRequest {
    projectId: string;
}

export interface ListProjectExpensesRequest {
    projectId: string;
}

export interface RetrieveReceiptInformationRequest {
    projectId: string;
    receiptName: string;
    file: Blob;
}

export interface UpdateExpenseRequest {
    projectId: string;
    expenseId: string;
    createExpenseRequest: CreateExpenseRequest;
}

/**
 * 
 */
export class ExpenseApi extends runtime.BaseAPI {

    /**
     * Freelancer create a project expense
          */
    async createProjectExpenseRaw(requestParameters: CreateProjectExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createProjectExpense().'
            );
        }

        if (requestParameters['createExpenseRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseRequest',
                'Required parameter "createExpenseRequest" was null or undefined when calling createProjectExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ExpenseResource>({
            path: `/project-freelancer/api/projet/{projectId}/expense`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseRequestToJSON(requestParameters['createExpenseRequest']),
        }, initOverrides);

        if (response._data) { response._data=ExpenseResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer create a project expense
          */
    async createProjectExpense(requestParameters: CreateProjectExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseResource> {
        const response = await this.createProjectExpenseRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete a non validated expense
          */
    async deleteExpenseRaw(requestParameters: DeleteExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteExpense().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling deleteExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-freelancer/api/projet/{projectId}/expense/{expenseId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete a non validated expense
          */
    async deleteExpense(requestParameters: DeleteExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExpenseRaw(requestParameters, initOverrides);
    }

    /**
     * Download Expense invoice pdf
          */
    async getExpenseInvoiceRaw(requestParameters: GetExpenseInvoiceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getExpenseInvoice().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling getExpenseInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Blob>({
            path: `/project-freelancer/api/projet/{projectId}/expense/{expenseId}/invoice`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Download Expense invoice pdf
          */
    async getExpenseInvoice(requestParameters: GetExpenseInvoiceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getExpenseInvoiceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Freelancer Project information for creating an expense
          */
    async getProjectExpenseInfoRaw(requestParameters: GetProjectExpenseInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseProjectInfoResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectExpenseInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseProjectInfoResource>({
            path: `/project-freelancer/api/projet/{projectId}/expense/project-info`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseProjectInfoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer Project information for creating an expense
          */
    async getProjectExpenseInfo(requestParameters: GetProjectExpenseInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseProjectInfoResource> {
        const response = await this.getProjectExpenseInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Freelancer show all the project expenses
          */
    async listProjectExpensesRaw(requestParameters: ListProjectExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseListResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseListResource>({
            path: `/project-freelancer/api/projet/{projectId}/expense`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseListResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer show all the project expenses
          */
    async listProjectExpenses(requestParameters: ListProjectExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseListResource> {
        const response = await this.listProjectExpensesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Analyse a receipt and sent all the information to fill the form automatically
          */
    async retrieveReceiptInformationRaw(requestParameters: RetrieveReceiptInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseReceiptResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling retrieveReceiptInformation().'
            );
        }

        if (requestParameters['receiptName'] == null) {
            throw new runtime.RequiredError(
                'receiptName',
                'Required parameter "receiptName" was null or undefined when calling retrieveReceiptInformation().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling retrieveReceiptInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['receiptName'] != null) {
            formParams.append('receiptName', requestParameters['receiptName'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<ExpenseReceiptResponse>({
            path: `/project-freelancer/api/projet/{projectId}/expense/receipt-analyse`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=ExpenseReceiptResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Analyse a receipt and sent all the information to fill the form automatically
          */
    async retrieveReceiptInformation(requestParameters: RetrieveReceiptInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseReceiptResponse> {
        const response = await this.retrieveReceiptInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Freelancer update an expense
          */
    async updateExpenseRaw(requestParameters: UpdateExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateExpense().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling updateExpense().'
            );
        }

        if (requestParameters['createExpenseRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseRequest',
                'Required parameter "createExpenseRequest" was null or undefined when calling updateExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ExpenseResource>({
            path: `/project-freelancer/api/projet/{projectId}/expense/{expenseId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseRequestToJSON(requestParameters['createExpenseRequest']),
        }, initOverrides);

        if (response._data) { response._data=ExpenseResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer update an expense
          */
    async updateExpense(requestParameters: UpdateExpenseRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseResource> {
        const response = await this.updateExpenseRaw(requestParameters, initOverrides);
        return response._data;
    }

}

/**
 * @export
 */
export const GetExpenseInvoiceTypeEnum = {
    Freelancer: 'FREELANCER',
    Client: 'CLIENT'
} as const;
export type GetExpenseInvoiceTypeEnum = typeof GetExpenseInvoiceTypeEnum[keyof typeof GetExpenseInvoiceTypeEnum];
